let openKey = null
const listeners = new Set()

const notify = () => {
  listeners.forEach(listener => listener(openKey))
}

export const subscribeVenueNavTooltipOpen = listener => {
  listeners.add(listener)
  listener(openKey)
  return () => listeners.delete(listener)
}

export const setVenueNavTooltipOpen = key => {
  const next = key || null
  if (openKey === next) return
  openKey = next
  notify()
}

export const hideVenueNavTooltip = key => {
  if (openKey !== key) return
  openKey = null
  notify()
}

export const closeVenueNavTooltips = () => {
  if (openKey == null) return
  openKey = null
  notify()
}

/** No tip on the tab you are already on — it would cover the page title. */
export const venueNavTooltipIfNotCurrent = (pathname, to, tooltip) => {
  if (!tooltip) return null
  const path = String(pathname || '')
  const href = String(to || '')
  if (!href) return tooltip
  if (path === href || (href && path.startsWith(`${href}/`))) return null
  return tooltip
}
